import React, { useState, useEffect } from 'react';
import { useStripe, useElements } from '@stripe/react-stripe-js';
import Text from './Text';
import PaymentMethod from './PaymentMethod';
import RedcatImage from './RedcatImage';
import { PAYMENT_METHOD } from '../libs/polygon-ordering/src/constants/paymentMethod';
import '../styles/stripe.css';
import { useAppSelector } from '../app/hooks';
import { OrderingSelectors } from 'polygon-ordering';

const { getStripeCurrency } = OrderingSelectors;

const PaymentMethodApplePay = () => {
  const [applePayEnabled, setApplePayEnabled] = useState<boolean | null>(null);
  const stripe = useStripe();
  const elements = useElements();
  const stripeCurrency = useAppSelector(getStripeCurrency);

  useEffect(() => {
    if (!stripe || !elements) {
      return;
    }

    const pr = stripe.paymentRequest({
      country: 'AU', // TODO: fix to avoid stripe overseas fees
      currency: stripeCurrency,
      total: {
        label: 'Payment Total:',
        amount: 0,
      },
    });

    pr.canMakePayment().then(result => {
      if (result?.applePay) {
        setApplePayEnabled(true);
      }
    });
  }, [stripe, elements]);

  return (
    <>
      {applePayEnabled && (
        <PaymentMethod
          method={PAYMENT_METHOD.APPLE_PAY}
          right={
            <div style={styles.buttonContainer}>
              <div style={styles.markContainer}>
                <RedcatImage
                  imagePath="https://assets.redcatcloud.com.au/webordering/Apple_Pay_Mark_RGB_041619.svg"
                  imageStyle={{ objectFit: 'contain' }}
                  size={54}
                />
              </div>
            </div>
          }
          subtitle={<Text themeKey="paymentMethodUnavailableReason">&nbsp;</Text>}
        />
      )}
    </>
  );
};

const styles: Styles = {
  buttonContainer: {
    position: 'relative',
  },
  markContainer: {
    position: 'absolute',
    top: -27,
    left: 'auto',
    right: 1,
  },
};

export default PaymentMethodApplePay;
